/* IRIS LANE theme behaviour: reveal on scroll, the campaign carousel, the filter
   chips, the product view chips and the mobile menu. No dependencies. */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Reveal: elements render visible by default; JS hides them and shows them as they arrive. */
  var reveals = document.querySelectorAll('[data-reveal]');
  if (!reduced && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.dataset.reveal = 'shown'; io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.06 });
    reveals.forEach(function (el) {
      el.dataset.reveal = 'pending';
      if (el.dataset.revealDelay) el.style.transitionDelay = el.dataset.revealDelay + 'ms';
      io.observe(el);
    });
  }

  /* Carousel: native horizontal scroll with snap points; auto-advance is just a scrollTo. */
  document.querySelectorAll('[data-carousel]').forEach(function (root) {
    var track = root.querySelector('[data-track]');
    var dots = root.querySelectorAll('[data-dot]');
    var n = track.children.length, index = 0, paused = false, timer = 0;
    var interval = parseInt(root.dataset.interval || '4500', 10);
    var goTo = function (i, behavior) {
      var next = ((i % n) + n) % n;
      track.scrollTo({ left: next * track.clientWidth, behavior: behavior || 'smooth' });
    };
    var sync = function () {
      index = Math.round(track.scrollLeft / track.clientWidth);
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === index ? 'true' : 'false'); });
    };
    var arm = function () {
      clearInterval(timer);
      if (reduced || paused || n < 2) return;
      timer = setInterval(function () { goTo(index + 1); }, interval);
    };
    track.addEventListener('scroll', sync, { passive: true });
    dots.forEach(function (d) { d.addEventListener('click', function () { goTo(parseInt(d.dataset.dot, 10)); }); });
    root.addEventListener('mouseenter', function () { paused = true; arm(); });
    root.addEventListener('mouseleave', function () { paused = false; arm(); });
    root.addEventListener('focusin', function () { paused = true; arm(); });
    root.addEventListener('focusout', function () { paused = false; arm(); });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') goTo(index + 1);
      if (e.key === 'ArrowLeft') goTo(index - 1);
    });
    window.addEventListener('resize', function () { goTo(index, 'auto'); });
    arm();
  });

  /* Mobile menu: one routine opens and closes it, so the icon and label always match. */
  var toggle = document.querySelector('[data-menu-toggle]');
  var mobile = document.querySelector('[data-mobile-nav]');
  var setMenu = function (open) {
    if (!toggle || !mobile) return;
    mobile.hidden = !open;
    toggle.setAttribute('aria-expanded', String(open));
    toggle.querySelector('.sr-only').textContent = open ? 'Close menu' : 'Open menu';
    toggle.querySelector('[data-bar="top"]').style.transform = open ? 'translateY(5.5px) rotate(45deg)' : '';
    toggle.querySelector('[data-bar="bottom"]').style.transform = open ? 'translateY(-5.5px) rotate(-45deg)' : '';
  };
  if (toggle && mobile) {
    toggle.addEventListener('click', function () { setMenu(mobile.hidden); });
    mobile.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { setMenu(false); }); });
  }

  /* Filter chips: show only the frames for the chosen audience. */
  document.querySelectorAll('[data-grid]').forEach(function (grid) {
    var chips = grid.querySelectorAll('[data-filter]');
    var cards = grid.querySelectorAll('[data-cards] > li');
    var count = grid.querySelector('[data-count]');
    var apply = function (f) {
      var shown = 0;
      cards.forEach(function (li) {
        var on = f === 'all' || li.dataset.audience === f;
        li.hidden = !on; if (on) shown++;
      });
      chips.forEach(function (c) { c.setAttribute('aria-pressed', c.dataset.filter === f ? 'true' : 'false'); });
      if (count) count.textContent = shown + ' frames shown';
    };
    chips.forEach(function (c) { c.addEventListener('click', function () { apply(c.dataset.filter); }); });
    var fromUrl = ((location.search + location.hash).match(/filter=(women|men|unisex)/) || [])[1];
    if (fromUrl) apply(fromUrl);
    /* Menu links carry the filter in the address. On the page that holds the
       grid, apply it in place and scroll, instead of reloading the page. */
    document.querySelectorAll('a[href*="filter="]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var f = (a.getAttribute('href').match(/filter=(women|men|unisex)/) || [])[1];
        if (!f) return;
        e.preventDefault();
        apply(f);
        history.replaceState(null, '', '?filter=' + f + '#collection');
        /* Close the phone menu first: it sits in the sticky header, so its
           height would otherwise throw the scroll target off. */
        setMenu(false);
        grid.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      });
    });
  });

  /* Product view chips. */
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var views = root.querySelectorAll('[data-view]');
    var chips = root.querySelectorAll('[data-chip]');
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        var i = c.dataset.chip;
        views.forEach(function (v) { v.hidden = v.dataset.view !== i; });
        chips.forEach(function (k) { k.setAttribute('aria-pressed', k === c ? 'true' : 'false'); });
      });
    });
  });

})();
